export default __webpack_public_path__ + "static/media/fd1.ae7cd385.jpg";